import { cn } from '@/lib/cn'

/** Initials fallback: first letter of the first two words, uppercased. */
export function initialsOf(name?: string | null): string {
  return (name ?? '?')
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

/**
 * Round avatar: the user's photo when they have one, initials otherwise.
 * Deliberately carries no colors of its own - the caller supplies the
 * surface recipe (portal vs storefront), this only handles the image.
 */
export default function Avatar({
  user,
  className,
}: {
  user: { name?: string | null; avatar_url?: string | null } | null | undefined
  className?: string
}) {
  return (
    <span className={cn('flex items-center justify-center overflow-hidden rounded-full', className)}>
      {user?.avatar_url ? (
        <img src={user.avatar_url} alt="" className="size-full object-cover" />
      ) : (
        initialsOf(user?.name)
      )}
    </span>
  )
}
